import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useRecoilValue } from 'recoil';

import Button from '~/components/Button';
import { navigationPathState } from '~/state/navigation';
import type { TStyles } from '~/types/emotion-styles';
import { canGoBack } from '~/utils/browser';
import { appendLeftArrow } from '~/utils/strings';

import styles from './styles';

const BackButton = ({ containerCss }: { containerCss?: TStyles }): JSX.Element | null => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { previousPath } = useRecoilValue(navigationPathState);

  if (!canGoBack()) {
    return null;
  }

  const navigateBack = () => {
    navigate(previousPath);
  };

  return (
    <div css={[styles.back, containerCss]}>
      <Button
        buttonCss={styles.backButton}
        onClick={navigateBack}
        label={appendLeftArrow(t('global.back'))}
        size="Small"
      />
    </div>
  );
};

export default BackButton;
